export default __webpack_public_path__ + "static/media/LucianoOliveira.37c76a0c.pdf";